module.exports = __webpack_public_path__ + "img/sergio.95478000.webp";